import { ClientUpgradeContent299vg0lx1tyfp as ClientUpgradeContent } from '../../request/ClientUpgradeContent.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { generateNonce3td15vdvbmmke as generateNonce } from '../../../../../../ktor-ktor-utils/io/ktor/util/Crypto.mjs';
import { Default_getInstance67416qwj1tmc as Default_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/encoding/Base64.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HeadersBuilder3h7sn3kkvu98m as HeadersBuilder } from '../../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WebSocketContentClass;
function WebSocketContent() {
  if (WebSocketContentClass === VOID) {
    class $ extends ClientUpgradeContent() {
      constructor() {
        super();
        var tmp = this;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().q1();
        var nonce = generateNonce(16);
        this_0.r1(Default_getInstance().tn(nonce));
        tmp.w5v_1 = this_0.toString();
        var tmp_0 = this;
        // Inline function 'kotlin.apply' call
        var this_1 = new (HeadersBuilder())();
        this_1.u4o('Upgrade', 'websocket');
        this_1.u4o('Connection', 'Upgrade');
        this_1.u4o('Sec-WebSocket-Key', this.w5v_1);
        this_1.u4o('Sec-WebSocket-Version', '13');
        tmp_0.x5v_1 = this_1.n37();
      }
      n50() {
        return this.x5v_1;
      }
      toString() {
        return 'WebSocketContent';
      }
    }
    initMetadataForClass($, 'WebSocketContent', WebSocketContent, VOID, VOID, [1]);
    WebSocketContentClass = $;
  }
  return WebSocketContentClass;
}
//region block: exports
export {
  WebSocketContent as WebSocketContentagsn4p79ffe0,
};
//endregion

//# sourceMappingURL=WebSocketContent.mjs.map
